import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Typography, Alert } from "@mui/material";
import Divider from "@mui/material/Divider";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReferralCodeQuery from "./ReferralCodeQuery";
import MyReferralCodesList from "./MyReferralCodesList";
import {
  getUserCodesApi,
  getCodeDetailsApi,
} from "../../../../../services/marketingApi";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";

export default function MyReferralCodes() {
  const [fetchedMyReferralCodes, setFetchedMyReferralCodes] = React.useState({
    docs: [],
  });
  const [queryMyReferralCodesData, setQueryMyReferralCodesData] =
    React.useState({});
  const [pageAndPerPage, setPageAndPerPage] = React.useState({
    page: 1,
    perPage: 10,
    totalPages: 0,
    hasNextPage: false,
    hasPrevPage: false,
    totalDocs: 0,
  });
  const [controlAlert, setControlAlert] = React.useState({
    open: true,
    message: "لطفا یکی از گزینه های بالا را انتخاب کنید و روی مشاهده کلیک کنید",
    severity: "warning",
    SkeletonDisplay: "none",
  });

  // کنترل شماره صفحه و تعداد در هر صفحه
  const setNumberPageAndPerPage = (type, number) => {
    let newValues = {};
    if (type == "page") newValues["page"] = number;
    if (type == "perPage") {
      newValues["perPage"] = number;
      newValues["page"] = 1;
    }
    const PageAndPerPageValue = { ...pageAndPerPage, ...newValues };
    setPageAndPerPage(PageAndPerPageValue);
    getMyReferralCodesFromBack(
      "getUserCodesApi",
      queryMyReferralCodesData,
      PageAndPerPageValue
    );
  };

  const getMyReferralCodesFromBack = async (
    request,
    data,
    paginateData = {}
  ) => {
    try {
      setControlAlert({
        open: true,
        message: "درخواست ارسال شد",
        severity: "warning",
        SkeletonDisplay: "Block",
      });
      setFetchedMyReferralCodes({ docs: [] });
      let paginate = { ...pageAndPerPage, ...paginateData };
      if (request == "getUserCodesApi") {
        let response = await getUserCodesApi(data, paginate);
        const resData = checkResponseData(response);
        if (resData["success"]) {
          setFetchedMyReferralCodes(resData["data"]);
          setControlAlert({
            open: true,
            message: "جواب آمد",
            severity: "warning",
            SkeletonDisplay: "none",
          });
          const { totalPages, hasNextPage, hasPrevPage, page, totalDocs } =
            resData["data"];
          const newValues = {
            totalPages,
            hasNextPage,
            hasPrevPage,
            page,
            totalDocs,
          };
          setPageAndPerPage({
            ...pageAndPerPage,
            ...paginateData,
            ...newValues,
          });
        } else {
          setControlAlert({
            open: true,
            message: "مشکلی پیش آمده است",
            severity: "warning",
            SkeletonDisplay: "none",
          });
        }
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      customToastify("error", errData["titles"] || errData["message"]);
      console.error(error);
    }
  };

  const getCodeDetails = async (data) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")

    try {
      const response = await getCodeDetailsApi(data)
      const resData = checkResponseData(response);
      if (resData["success"]) {
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        if (resData["data"]["data"].length > 0) {
          return resData["data"]["data"][0];
        } else {
          toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
        }
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      console.error(error);
    }
  };

  return (
    <Grid container sx={{ textAlign: "justify", height: "100vh" }}>
      <Box sx={{ width: "100%", px: 1 }}>
        {" "}
        <Accordion sx={{ mt: 1 }} defaultExpanded={true}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>فیلتر اطلاعات</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ReferralCodeQuery
              setQueryMyReferralCodesData={setQueryMyReferralCodesData}
              getMyReferralCodesFromBack={getMyReferralCodesFromBack}
            />
          </AccordionDetails>
        </Accordion>
        <Divider />
        <Collapse in={controlAlert.open}>
          <Alert
            severity={controlAlert.severity}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setControlAlert({
                    open: false,
                    message: "",
                    severity: "info",
                    SkeletonDisplay: "none",
                  });
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{ mb: 2 }}
          >
            {controlAlert.message}
          </Alert>
        </Collapse>
        <Stack sx={{ display: controlAlert.SkeletonDisplay }} spacing={1}>
          <Skeleton />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
        </Stack>
        <MyReferralCodesList
          fetchedMyReferralCodes={fetchedMyReferralCodes}
          pageAndPerPage={pageAndPerPage}
          setNumberPageAndPerPage={setNumberPageAndPerPage}
          getCodeDetails={getCodeDetails}
        />
      </Box>
      {/* <ToastContainer
        position="bottom-center"
        autoClose={500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      /> */}
    </Grid>
  );
}

// fetchedMyReferralCodes
let fetchedMyReferralCodesSample = {
  data: {
    success: true,
    message: " درخواست با موفقیت انجام شد",
    data: {
      docs: [
        {
          _id: "6301082606ab01bc409093c3",
          marketingCode: "sdfsad6f46asd",
          firstUserDiscount: 50,
          createdAt: "2022-08-20T16:13:26.175Z",
          anotherUserDiscount: 9,
          status: false,
        },
      ],
      totalDocs: 50,
      limit: 1,
      totalPages: 25,
      page: 8,
      pagingCounter: 1,
      hasPrevPage: false,
      hasNextPage: true,
      prevPage: null,
      nextPage: 2,
    },
  },
};
